import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { ShopifySyncPage } from "@/components/data-sources/shopify-sync-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-sync/shopify-orders",
  loader: async () => {
    const [syncSettingsRes, syncHistoryRes, ordersRes] = await Promise.all([
      fetch("/api/settings/shopify-sync"),
      fetch("/api/shopify/orders/sync-history"),
      fetch("/api/shopify/orders?pageSize=1"),
    ]);
    const syncSettings = syncSettingsRes.ok ? await syncSettingsRes.json() : null;
    const syncHistory = syncHistoryRes.ok ? await syncHistoryRes.json() : { results: [] };
    const ordersData = ordersRes.ok ? await ordersRes.json() : { total: 0 };
    return {
      shopifySyncSettings: syncSettings ?? {
        intervalMs: 3600000,
        lastSyncedAt: null,
        backfillCompletedAt: null,
        schedulerActive: false,
      },
      shopifySyncHistory: syncHistory.results ?? [],
      totalLocalOrders: ordersData.total ?? 0,
    };
  },
  component: ShopifySyncPageGuard,
});

function ShopifySyncPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  // biome-ignore lint/suspicious/noExplicitAny: better-auth session type lacks role
  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <ShopifySyncPage />;
}
